/**
 *
 * FBFormsPreview
 *
 */

import React, { memo, useCallback } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// styles
import './style.scss';

// antd component
import { Radio, Input, Checkbox } from 'antd';
const { TextArea } = Input;

// components
import {
  FBSectionHeader,
} from 'components/Communications';
import ErrorBoundary from 'engine/ErrorBoundary';


function FBFormsPreview({
  type,
  forms,
  // default props
  className,
  ...rest
}) {
  const childClassNames = classNames('tcf-fb-forms-group-preview', 'tcf-fb-group-preview', className);

  const prepearGroup = useCallback((fields, type, name) => {
    let gruopOptions = [];
    if (!!fields?.['field-input'] && type) {
      gruopOptions = fields?.['field-input']?.map((opt, indx) => {
        const label = opt?.[`${type}-input`];
        return label && {
          label,
          value: label,
          key: `${type}-${name}-${indx}`
        }
      }).filter(el => !!el && Object.keys(el)?.length > 0)
    }
    return gruopOptions;
  }, [forms])

  const generatePreviewByType = useCallback((row, name) => {
    switch (row['field-type']) {
      case 'textarea':
        return (
          <>
            <TextArea
              key={`preview-forms-textarea-${name}`}
              disabled
              row="4"
              placeholder={`Réponse gratuite`}
            />
          </>
        );

      case 'checkbox':
        const checkboxOptions = prepearGroup(row, 'checkbox', name);
        return checkboxOptions?.length > 0 && (
          <ErrorBoundary key={`preview-forms-checkbox-${name}-ErrorBoundary`}>
            <Checkbox.Group
              key={`preview-forms-checkbox-${name}`}
              options={checkboxOptions}
              disabled
            />
          </ErrorBoundary>
        );

      case 'radio':
        const radioOptions = prepearGroup(row, 'radio', name)
        return radioOptions?.length > 0 && (
          <ErrorBoundary key={`preview-forms-radio-${name}-ErrorBoundary`}>
            <Radio.Group
              key={`preview-forms-radio-${name}`}
              options={radioOptions}
              disabled
            />
          </ErrorBoundary>
        );

      case 'input':
        return (
          <>
            <Input key={`preview-forms-input-${name}`} disabled placeholder={`Courte réponse`} />
          </>
        );

      default: <></>;
    }
  }, [forms])

  return !!forms && (
    <div {...rest} className={childClassNames}>
      <FBSectionHeader key={`preview-${type}`} type={type} />
      <div className='tcf-fb-group-preview__content'>
        <div className='form-header'>
          {!!forms[`${type}-title`] && (
            <h3 className="form-title">{forms[`${type}-title`]}</h3>
          )}
          {!!forms[`${type}-description`] && (
            <p className="form-description">{forms[`${type}-description`]}</p>
          )}
        </div>
        {forms[`${type}-fields`]?.map((row, indx) => {
          return !!row && (
            <div key={`preview-form-form-row-${indx}`} className='form-row'>
              <h4 key={`preview-row-title-${type}-${indx}`} className={`form-row__title ${row[`field-type`]}`}>{row[`field-title`]}</h4>
              <div key={`preview-row-field-${type}-${indx}`} className='form-row__field'>
                {generatePreviewByType(row, indx)}
              </div>
            </div>
          );
        })}
      </div>

    </div>
  );
}

FBFormsPreview.defaultProps = {
  type: 'forms',
};
FBFormsPreview.propTypes = {
  forms: PropTypes.oneOfType([PropTypes.object, PropTypes.bool])
};

export default memo(FBFormsPreview);
